import {
  Heading,
  Box,
  SimpleGrid,
  Container,
  Body,
  Button,
} from '@hover/blueprint';
import React from 'react';
import { Link } from 'gatsby';
import { TrustedByNamesSlide } from '../../common';

const FitIntoYourMobile: React.FC = () => (
  <Box d={{ base: 'none', desktop: 'flex' }} w="100%" px={500} py={1100}>
    <SimpleGrid w="100%" columns={2} spacing={1000} alignItems="center">
      <Box h="480px">
        <TrustedByNamesSlide />
      </Box>
      <Container py={1000} maxW="lg">
        <Heading size={700}>
          We fit into your business, not the other way around
        </Heading>
        <Heading size={500} isDisplay>
          HOVER integrates with your favorite tools, so you can share
          measurements and estimates and track jobs across a variety of
          platforms. It shouldn&apos;t be hard to make things easier.
        </Heading>
        <Box maxW="280px">
          <Button
            mt={700}
            as={Link}
            size="large"
            to={`${process.env.GATSBY_V2_PREFIX}/partners`}
          >
            <Body letterSpacng="1px" color="neutral.0" size={300} isBold>
              PARTNERS AND INTEGRATIONS
            </Body>
          </Button>
        </Box>
      </Container>
    </SimpleGrid>
  </Box>
);

export default FitIntoYourMobile;
